import React from 'react';

const Contact = () => {
    return (
        <div className="min-h-screen bg-gray-900">
            <iframe 
                src="/contact_table.html" 
                title="Account Contacts"
                className="w-full h-screen"
                style={{ border: 'none' }}
            />
        </div>
    );
};

export default Contact;


// const express = require("express");
// const mysql = require("mysql2");
// const path = require("path");
// const fs = require("fs");
// const cors = require("cors");

// const app = express();

// // Enable CORS for cross-origin access
// app.use(cors());

// // Trust NGINX proxy headers
// app.set("trust proxy", true);

// // Define absolute paths for your web directory
// const PUBLIC_DIR = "/Applications/XAMPP/xamppfiles/htdocs/Inventory_Page";
// const ASSETS_DIR = path.join("/Applications/XAMPP/xamppfiles/htdocs/Sales_Page", "Assets");
// const CATEGORIES_DIR = path.join(ASSETS_DIR, "categories");

// // Serve static files (index.html, CSS, JS, images)
// app.use(express.static(PUBLIC_DIR));
// app.use("/Assets", express.static(ASSETS_DIR));

// // Database connection
// const dbConfig = {
//     host: "127.0.0.1", // Use "localhost" if running on the same server
//     user: "BB",
//     password: "Tucker01**", // Move this to an environment variable for security
//     database: "Products",
//     multipleStatements: true
// };

// const connection = mysql.createConnection(dbConfig);
// connection.connect((err) => {
//     if (err) {
//         console.error("❌ Database connection failed:", err.message);
//         process.exit(1); // Exit the app if the database fails to connect
//     }
//     console.log("✅ Connected to the Products database successfully!");
// });

// // Function to sanitize directory names
// function sanitizePath(name) {
//     return String(name)
//         .trim()
//         .replace(/[^\w\s-]/g, "")
//         .replace(/\s+/g, "_");
// }

// Function to get the first image from the category directory
// function getFirstImageFromDirectory(category, internalCode) {
//     if (!category || !internalCode) return null;

//     const sanitizedCategory = sanitizePath(category);
//     const sanitizedCode = sanitizePath(internalCode);
//     const dirPath = path.join(CATEGORIES_DIR, sanitizedCategory, sanitizedCode);

//     console.log('Checking directory:', dirPath); // Add logging for debugging

//     if (!fs.existsSync(dirPath)) {
//         console.log(`⚠️ Directory not found: ${dirPath}`);
//         return null;
//     }

//     try {
//         const files = fs.readdirSync(dirPath);
//         const imageFiles = files.filter(file => {
//             const ext = path.extname(file).toLowerCase();
//             return [".jpg", ".jpeg", ".png", ".gif"].includes(ext);
//         });

//         if (imageFiles.length > 0) {
//             const imagePath = `/Assets/categories/${sanitizedCategory}/${sanitizedCode}/${imageFiles[0]}`;
//             console.log('Found image:', imagePath); // Add logging for debugging
//             return imagePath;
//         }
//     } catch (error) {
//         console.error(`❌ Error reading directory for ${internalCode}:`, error);
//     }

//     return null;
// }

// // ✅ Serve index.html when visiting "/"
// app.get("/contact", (req, res) => {
//     // res.sendFile(path.join(PUBLIC_DIR, "webtable.html"));
//     res.sendFile("./webtable.html");
// });

// // ✅ Test API endpoint
// app.get("/test", (req, res) => {
//     res.json({ message: "✅ Server is running on inventory.sunwinnyc.com!" });
// });

// // ✅ Get categories endpoint
// app.get("/api/categories", (req, res) => {
//     console.log("📢 Categories endpoint hit");
//     const sql = "SELECT DISTINCT category FROM Inventory ORDER BY category";

//     connection.query(sql, (err, results) => {
//         if (err) {
//             console.error("❌ SQL Error:", err.message);
//             return res.status(500).json({ error: "Error fetching categories." });
//         }

//         const categories = results
//             .map(row => row.category)
//             .filter(category => category && category.trim())
//             .map(category => ({
//                 original: category,
//                 sanitized: sanitizePath(category)
//             }));

//         res.json(categories);
//     });
// });

// // ✅ Get products endpoint
// app.get("/api/pricing", (req, res) => {
//     const category = req.query.category;
//     const stockStatus = req.query.stock;
//     console.log(`📢 Products endpoint hit - Category: ${category}, Stock: ${stockStatus}`);

//     let sql = `
//         SELECT 
//             product_number,
//             quantity_on_hand,
//             product_name,
//             category,
//             gender,
//             composition,
//             weave_classification,
//             year,
//             season,
//             fashion_type,
//             element,
//             dept,
//             product_size,
//             designer,
//             technique,
//             internal_code,
//             weight,
//             style_info,
//             select_development,
//             remarks,
//             scheme_name
//         FROM Inventory
//         WHERE 1=1
//     `;

//     const queryParams = [];

//     if (category) {
//         sql += " AND category = ?";
//         queryParams.push(category);
//     }

//     if (stockStatus) {
//         if (stockStatus === "in") {
//             sql += " AND quantity_on_hand > 0";
//         } else if (stockStatus === "out") {
//             sql += " AND (quantity_on_hand = 0 OR quantity_on_hand IS NULL)";
//         }
//     }

    // connection.query(sql, queryParams, (err, results) => {
    //     if (err) {
    //         console.error("❌ SQL Error:", err.message);
    //         return res.status(500).json({ error: "Error fetching data from Inventory table." });
    //     }

    //     const dataArray = Array.isArray(results) ? results : [];

    //     // Attach image paths to each product
    //     dataArray.forEach(row => {
    //         if (row.category && row.internal_code) {
    //             row.picture = getFirstImageFromDirectory(row.category, row.internal_code);
    //         } else {
    //             row.picture = null;
    //         }
    //     });

    //     res.json({
    //         data: dataArray,
    //         recordsTotal: dataArray.length,
    //         recordsFiltered: dataArray.length
    //     });
    // });
// });

// // // ✅ Start the server and listen on all available IPs (0.0.0.0)
// // const PORT = process.env.PORT || 446;
// // app.listen(PORT, "0.0.0.0", () => {
// //     console.log(`🚀 Server is running on https://inventory.sunwinnyc.com at port ${PORT}`);
// // });

// function getLogoPath(imageName) {
//     if (!imageName) return null;
//     return `/Assets/images/${imageName}`;
// }

